module.exports = __webpack_public_path__ + "img/51_40.6ae3c32b.png";